import styled from '@emotion/styled'

export const Form = styled('form')`
  display: flex;
  gap: 40px;
  height: 100%;
  padding: 24px 20px;
`

export const mainBox = {
  display: 'flex',
  width: '35vw',
  flexDirection: 'column',
  gap: '15px',
  height: '45vh',
}

export const modalColumnHeadingBox = {
  display: 'flex',
  width: '300px',
  flexDirection: 'column',
  gap: '15px',
}

export const controllerBox = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
}
